import React, { useRef, useState } from "react";

function ComponentPriceAE({ Product, Amounts, LastPrice, setAmounts }) {
  const inputRefs = useRef([]);
  const [ActiveProd, SetActiveProd] = useState();

  const handleKeyDown = (e, index) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const DoChange = async (ProductId, Amount) => {
    let copy = [...Amounts];
    if (Amount == "") {
      let excist = copy.find((e) => e.Id == ProductId);
      if (excist) {
        copy = copy.filter((e) => e.Id != ProductId);
      }
    } else {
      let excist = copy.find((e) => e.Id == ProductId);
      if (excist) {
        copy.find((e) => e.Id == ProductId).Price = Amount.replace(/,/g, "");
      } else {
        let data = {
          Id: ProductId,
          Price: Amount.replace(/,/g, ""),
        };
        copy.push(data);
      }
    }
    setAmounts(copy);
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
        p.productBerandId,
        p.productTypeId,
        p.productSeriesId,
        p.symbol,
        p.productSeriesEndId,
        p.productRamId,
        p.productRomId,
        p.productNetworkId,
        p.productCountryId,
        p.isInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center w-100 tableC">
        <table className="table tableMore">
          <thead className="sticky-header">
            <tr className="trTable">
              <th>نام محصول</th>
              <th>رنگ</th>
              <th>قیمت</th>
              <th>اخرین قیمت</th>
            </tr>
          </thead>
          {Product &&
            groupProducts(Product).map((group, gIndex) => (
              <tbody key={gIndex}>
                {group.map((itemPro, keyPro) => {
                  return (
                    <tr key={itemPro.id}>
                      {keyPro === 0 && (
                        <>
                          <td rowSpan={group.length}>
                            {itemPro.productTypeName != " " &&
                              itemPro.productTypeName + " "}
                            {itemPro.productSeriesName != " " &&
                              itemPro.productSeriesName}
                            {itemPro.symbol}
                            {itemPro.productSeriesEndName != " "
                              ? itemPro.productSeriesEndName + " "
                              : " "}
                            {itemPro.productRamName != " " &&
                              itemPro.productRamName + "/"}
                            {itemPro.productRomName != " " &&
                              itemPro.productRomName + " "}
                            {itemPro.productNetworkName != " " &&
                              itemPro.productNetworkName + " "}
                            {itemPro.productCountryName != " " &&
                              itemPro.productCountryName + " "}
                            {itemPro.isInsurance && "بیمه"}
                          </td>
                        </>
                      )}
                      <td> {itemPro.productColorName} </td>
                      <td
                        className={
                          LastPrice.find((w) => w.productId == itemPro.id)
                            ?.lastPrice *
                            1.1 <
                            Amounts.find((e) => e.Id === itemPro.id)?.Price ||
                          LastPrice.find((w) => w.productId == itemPro.id)
                            ?.lastPrice *
                            0.9 >
                            Amounts.find((e) => e.Id === itemPro.id)?.Price
                            ? "ghermez"
                            : ""
                        }
                      >
                        <input
                          ref={(el) => (inputRefs.current[keyPro] = el)}
                          onFocus={() => SetActiveProd(itemPro.id)}
                          value={Amounts.find((e) => e.Id === itemPro.id)
                            ?.Price.toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          onChange={(e) => {
                            DoChange(itemPro.id, e.target.value);
                          }}
                          onKeyDown={(e) => handleKeyDown(e, keyPro)}
                          className="m-2"
                          type="text"
                        />
                      </td>
                      <td
                        className={
                          LastPrice.find((w) => w.productId == itemPro.id)
                            ?.lastPrice *
                            1.1 <
                            Amounts.find((e) => e.Id === itemPro.id)?.Price ||
                          LastPrice.find((w) => w.productId == itemPro.id)
                            ?.lastPrice *
                            0.9 >
                            Amounts.find((e) => e.Id === itemPro.id)?.Price
                            ? "ghermez"
                            : ""
                        }
                      >
                        {LastPrice.find((w) => w.productId == itemPro.id)
                          ?.lastPrice?.toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ))}
        </table>
      </div>
    </>
  );
}

export default ComponentPriceAE;
